export default __webpack_public_path__ + "static/media/femimed_gabinet_1_thumbnail.a493dd20.webp";